import { render } from "./SingleSelectCombo.vue?vue&type=template&id=3b0b4982"
import script from "./SingleSelectCombo.vue?vue&type=script&lang=js"
export * from "./SingleSelectCombo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__